export class ExistingPlayerErrors {

    static otp_user_not_found_error_code = 1;
    static otp_user_sub_not_found_error_code = 2;
    static otp_otp_user_key_not_error_code = 3;
    static otp_max_retry_error_code = 4;
    static otp_user_timezone_error_code = 5;
    static invalid_otp_error_code = 6;
    static account_link_otp_verification_failed = 7;
    static account_link_phone_number_email_id_not_available = 8;
    static account_link_invalid_otp_retry_limit_exceeded = 9;
    static account_link_otp_country_code_not_found = 10;
    static player_account_not_available_code = 11;
    static duplicate_account_number_found = 12;
}